module.exports = __webpack_public_path__ + "img/image-56.6a180c48.webp";